import React from 'react';

/* WithInfo Screen */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0103mAction } from '../../..//redux/slice/com/com0103m_slice';

import { Layout, Row, Col } from 'antd';
import * as component from 'libs/components';
import { Routes, Route } from 'react-router';


const WithInfoContents = () => {
    const dispatch = useAppDispatch();
    const allLnbMenuItems = useAppSelector((state) => state.Frame.allLnbMenuItems);
    const activeKey       = useAppSelector((state) => state.Frame.activeKey);
    const activeProps     = useAppSelector((state) => state.Frame.activeProps);

    const routeItem = React.useCallback(() => {
        let rtn = null;

        if (!activeKey) {
            return null;
        }
        let tmpActiveKey = activeKey ? activeKey : 'MCOM2021006';

        let menuItem:any = allLnbMenuItems.filter((tab:any) => tab.key === tmpActiveKey)[0];
        let pgmPath:string = menuItem.pgmId;
        let props = {pgmPath:pgmPath, props : activeProps };
        
        dispatch(Com0103mAction.setBoardDcd(menuItem.relVal));
        
        rtn = component.fn_getComponent(props);

        return rtn;
    }, [activeKey]);

    return ( 
        <Layout style={{ margin: '2px', padding: '0 10px 24px', borderRadius: '0.5em', backgroundColor: 'white' }}>
            <Row>
                <Col>
                    <Routes>
                        <Route key={activeKey} path={'/' + activeKey} element={routeItem()} />
                    </Routes>
                </Col>
            </Row>
        </Layout>   
    );

}

export default WithInfoContents;